var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurgeons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 5.31929C16.3234 6.08955 16.4602 6.89833 16.8802 7.5677C17.3001 8.23708 17.9687 8.71222 18.739 8.8886C19.5092 9.06499 20.318 8.92816 20.9874 8.50823C21.6568 8.0883 22.1319 7.41966 22.3083 6.64941C22.4847 5.87915 22.3479 5.07037 21.9279 4.401C21.508 3.73162 20.8394 3.25648 20.0691 3.0801C19.2988 2.90371 18.4901 3.04053 17.8207 3.46047C17.1513 3.8804 16.6762 4.54904 16.4998 5.31929Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98286 0.838867H1.10571V7.00001C1.10571 8.46325 1.68687 9.86659 2.72138 10.9014C3.75588 11.9363 5.15904 12.5178 6.62228 12.5183C7.3471 12.5185 8.06486 12.376 8.73457 12.0987C9.40427 11.8215 10.0128 11.4151 10.5254 10.9026C11.038 10.3902 11.4446 9.78178 11.7221 9.11216C11.9995 8.44254 12.1423 7.72483 12.1423 7.00001V0.838867H10.2669",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73199 12.5711V14.642C6.73199 15.4745 6.89597 16.2989 7.21456 17.068C7.53314 17.8371 8.0001 18.536 8.58877 19.1247C9.77764 20.3135 11.3901 20.9814 13.0714 20.9814C13.9041 20.9817 14.7286 20.8178 15.4979 20.4994C16.2673 20.1809 16.9663 19.7139 17.5552 19.1253C18.144 18.5366 18.6111 17.8376 18.9298 17.0684C19.2485 16.2991 19.4126 15.4746 19.4126 14.642V9.30371",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgeons);
export default __webpack_public_path__ + "static/media/surgeons.572fd2326f321c16d4b6453fdfa293e8.svg";
export { ForwardRef as ReactComponent };